import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LinkWrap from "../../../LinkWrap/component";
import featureAttr from "../../../../utils/featureAttr";
import styles from "./styles/themes/default.module.scss";
import { getStorageData, setStorageData } from "./utils";
import log from "../../../../utils/logger/library";
import { getFeedCookie } from "../../../../utils/cookies/library";
import { AUTHED_COOKIE } from "../../../../utils/cookies/constants";
import {
    signUpText,
    signInText,
    descriptionText,
    titleText,
} from "./constants";
import { useSelector } from "react-redux";
const gemIcon = require("./resources/images/gem.svg");

const AccountCTA = () => {
    const { contentId } = useSelector((state) => state.app);
    const location = useLocation();
    const currentPath = location.pathname;
    const [showCTA, setShowCTA] = useState(false);

    const signInUrl =
        "https://www.cbc.ca/account/login?returnto=" +
        currentPath +
        "&referrer=" +
        currentPath;
    const signUpUrl =
        "https://www.cbc.ca/account/signup?returnto=" +
        currentPath +
        "&referrer=" +
        currentPath;

    useEffect(() => {
        //the requirement is to show the CTA to an unauthenticated user after their 3rd story view
        try {
            const uieCookie = getFeedCookie(AUTHED_COOKIE);
            if (!uieCookie) {
                let ctaCtr = 1;
                const parsedStorage = getStorageData("stronglySuggestedCTA");
                if (parsedStorage?.count) {
                    ctaCtr =
                        parsedStorage.count < 3 ? parsedStorage.count + 1 : 1;
                    setStorageData("stronglySuggestedCTA", {
                        count: ctaCtr,
                    });
                } else {
                    setStorageData("stronglySuggestedCTA", {
                        count: ctaCtr,
                    });
                }
                const shouldShowCTA = ctaCtr === 3;
                setShowCTA(shouldShowCTA);
            }
        } catch (error) {
            log.error("(AccountCTA) Error parsing storage data", error);
        }
    }, [contentId]);

    if (!showCTA) {
        return null;
    }

    return (
        <div
            className={styles.accountCTA}
            data-testid="account-cta"
            role="complementary"
            aria-label="Call to Action"
        >
            <img alt={"cbc gem"} src={gemIcon} className={styles.image} />

            <div className={styles.descriptionContainer}>
                <p className={styles.title}>{titleText}</p>
                <p className={styles.description}>{descriptionText}</p>
            </div>
            <div className={styles.buttonContainer}>
                <LinkWrap
                    className={styles.signIn}
                    url={signInUrl}
                    external={false}
                    {...featureAttr({
                        name: "link",
                        instance: "suggested-authentication",
                    })}
                >
                    {signInText}
                </LinkWrap>
                <LinkWrap
                    className={styles.signUp}
                    url={signUpUrl}
                    external={false}
                    {...featureAttr({
                        name: "link",
                        instance: "suggested-authentication",
                    })}
                >
                    {signUpText}
                </LinkWrap>
            </div>
        </div>
    );
};

export default AccountCTA;
